import memoizeOne from 'memoize-one';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { HELP_BUTTON_UI_STORAGE_KEY } from './constants.tsx';

type AccountId = string;

export const updateHelpButtonState = async (
	accountId: AccountId | null,
	data: {
		helpPanelMenu: {
			releaseNotesNotifications: number;
		};
	},
): Promise<void> => {
	if (accountId !== null) {
		try {
			await setUserProperties(accountId, HELP_BUTTON_UI_STORAGE_KEY, JSON.stringify(data));
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireErrorAnalytics({
				error: e,
				meta: {
					id: 'updateServerHelpButtonState',
					packageName: 'jiraAtlassianNavigation',
					teamName: 'navigation',
				},
			});
		}
	}
};

export const getHelpButtonState = memoizeOne(async (accountId: AccountId) => {
	try {
		// @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
		const { helpPanelMenu: userPropertiesHelpButtonValue } = await getUserProperty(
			accountId,
			HELP_BUTTON_UI_STORAGE_KEY,
		);

		return userPropertiesHelpButtonValue;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		fireErrorAnalytics({
			error: e,
			meta: {
				id: 'getHelpButtonState',
				packageName: 'jiraAtlassianNavigation',
				teamName: 'navigation',
			},
		});
	}

	return null;
});
